import React from "react";
import { Table, Form, Pagination } from "react-bootstrap";
import editIcon from "../../assets/edit.svg";

const DAY_ORDER = [
  "sunday",
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
];

const capitalizeFirstLetter = (string) => string?.replace(/\b(\w)/g, (s) => s?.toUpperCase());

const getStatusStyle = (status) => {
  switch (status) {
    case "active":
      return {
        backgroundColor: "white",
        color: "#115F04",
        border: "1px solid #115F04",
        padding: "6px 16px 6px 16px",
        borderRadius: "12px",
      };
    case "inactive":
      return {
        backgroundColor: "white",
        color: "#F2994A",
        border: "1px solid #F2994A",
        padding: "6px 16px 6px 16px",
        borderRadius: "12px",
      };
    default:
      return {
        backgroundColor: "white",
        color: "#B25E09",
        border: "1px solid #B25E09",
        padding: "6px 16px 6px 16px",
        borderRadius: "12px",
      };
  }
};

const determineStatus = (loc) => {
  const statusText = loc?.status ? capitalizeFirstLetter(loc.status) : "Status Unknown";
  return <span style={getStatusStyle(statusText.toLowerCase())}>{statusText}</span>;
};

const formatDeliveryDays = (deliveryDays) => {
  if (!deliveryDays || deliveryDays.length === 0) return "-";
  return deliveryDays
    .slice()
    .sort((a, b) => DAY_ORDER.indexOf(a.toLowerCase()) - DAY_ORDER.indexOf(b.toLowerCase()))
    .map((day) => day.charAt(0).toUpperCase() + day.substring(1, 3))
    .join(", ");
};

const LocationsTable = ({
  displayLocations,
  selectedLocationsId,
  handleToggleSelectAll,
  handleCheckboxChange,
  tableRef,
  pagination,
  handlePageChange,
  navigate,
  setCurrentLocation,
  setShowDeleteModal,
}) => {
  return (
    <div className="list-body">
      <div className="list-scroll">
        <Table hover ref={tableRef} id="delivery-table" className="my-3">
          <thead>
            <tr style={{ fontWeight: "600" }} className="mb-2">
              <th style={{ fontWeight: "600" }} className="pb-3">
                <Form.Check
                  checked={
                    displayLocations.length > 0 &&
                    displayLocations.every((loc) => selectedLocationsId.includes(loc.id || loc?._id))
                  }
                  onChange={handleToggleSelectAll}
                />
              </th>
              <th style={{ fontWeight: "600" }} className="pb-3">
                Delivery Area
              </th>
              <th style={{ fontWeight: "600" }} className="pb-3">
                State
              </th>
              <th style={{ fontWeight: "600" }} className="pb-3">
                Delivery Fee
              </th>
              <th style={{ fontWeight: "600" }} className="pb-3">
                Delivery Day(s)
              </th>
              <th style={{ fontWeight: "600" }} className="pb-3">
                Status
              </th>
              <th style={{ fontWeight: "600" }} className="pb-3"></th>
            </tr>
          </thead>
          <tbody>
            {displayLocations.map((loc) => (
              <tr
                key={loc.id || loc?._id}
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "#333333",
                  paddingTop: "15px",
                  paddingBottom: "15px",
                }}
              >
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                  <Form.Check
                    checked={selectedLocationsId.includes(loc.id || loc?._id)}
                    onChange={(e) =>
                      handleCheckboxChange(loc.id || loc?._id, loc.name, e.target.checked)
                    }
                  />
                </td>
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>{loc.name}</td>
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>{loc?.state?.name}</td>
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                  ₦{loc?.deliveryFee?.toLocaleString()}
                </td>
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                  {formatDeliveryDays(loc?.deliveryDays)}
                </td>

                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>{determineStatus(loc)}</td>
                <td style={{ paddingTop: "15px", paddingBottom: "15px" }}>
                  <img
                    src={editIcon}
                    alt="edit"
                    className="me-3"
                    style={{ cursor: "pointer", paddingBottom: "8px" }}
                    onClick={() =>
                      navigate(`/delivery-locations/${loc?._id}`, {
                        state: { isEditing: true },
                      })
                    }
                  />
                  <i
                    className={
                      loc?.status?.toLowerCase() === "active"
                        ? "bi bi-dash-circle"
                        : "bi bi-plus-circle"
                    }
                    style={{
                      cursor: "pointer",
                      color: loc?.status?.toLowerCase() === "active" ? "red" : "green",
                      fontSize: "1.2rem",
                    }}
                    onClick={() => {
                      setCurrentLocation(loc);
                      setShowDeleteModal(true);
                    }}
                  ></i>
                </td>
                <td
                  style={{
                    paddingTop: "15px",
                    paddingBottom: "15px",
                    cursor: "pointer",
                    textDecoration: "underline",
                    color: "#469B12",
                  }}
                  onClick={() =>
                    navigate(`/delivery-locations/${loc?._id}`, { state: { isEditing: false } })
                  }
                >
                  View
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {displayLocations.length > 0 && pagination.totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center py-3">
          <p style={{ fontWeight: "500", color: "#919EAB" }}>
            Showing {displayLocations.length} of {pagination.totalLocations} locations
          </p>
          {pagination.totalPages > 1 && (
            <Pagination className="custom-pagination d-flex gap-2">
              <button
                className="btn btn-outline-secondary pb-0 px-2"
                disabled={pagination.currentPage === 1}
                onClick={() => handlePageChange(pagination.currentPage - 1)}
                style={{
                  border: pagination.currentPage === 1 ? "none" : "1px solid #C4CDD5",
                  color: pagination.currentPage === 1 ? "#C4CDD5" : "#000000",
                }}
              >
                <h6>
                  <i className="bi bi-chevron-left"></i>
                </h6>
              </button>

              <Pagination.Item
                onClick={() => handlePageChange(1)}
                active={pagination.currentPage === 1}
              >
                1
              </Pagination.Item>

              {pagination.totalPages > 1 && (
                <>
                  {pagination.currentPage > 3 && <Pagination.Ellipsis disabled />}

                  {pagination.currentPage > 2 && (
                    <Pagination.Item onClick={() => handlePageChange(pagination.currentPage - 1)}>
                      {pagination.currentPage - 1}
                    </Pagination.Item>
                  )}

                  {pagination.currentPage !== 1 &&
                    pagination.currentPage !== pagination.totalPages && (
                      <Pagination.Item active>{pagination.currentPage}</Pagination.Item>
                    )}

                  {pagination.currentPage < pagination.totalPages - 1 && (
                    <Pagination.Item onClick={() => handlePageChange(pagination.currentPage + 1)}>
                      {pagination.currentPage + 1}
                    </Pagination.Item>
                  )}

                  {pagination.currentPage < pagination.totalPages - 2 && (
                    <Pagination.Ellipsis disabled />
                  )}

                  <Pagination.Item
                    onClick={() => handlePageChange(pagination.totalPages)}
                    active={pagination.currentPage === pagination.totalPages}
                  >
                    {pagination.totalPages}
                  </Pagination.Item>
                </>
              )}

              <button
                className="btn btn-outline-secondary pb-0 px-2"
                disabled={pagination.currentPage === pagination.totalPages}
                onClick={() => handlePageChange(pagination.currentPage + 1)}
                style={{
                  border:
                    pagination.currentPage === pagination.totalPages ? "none" : "1px solid #C4CDD5",
                  color: pagination.currentPage === pagination.totalPages ? "#C4CDD5" : "#000000",
                }}
              >
                <h6>
                  <i className="bi bi-chevron-right"></i>
                </h6>
              </button>
            </Pagination>
          )}
        </div>
      )}
    </div>
  );
};

export default LocationsTable;
